import React from 'react';
import { createApp, Router } from '@medlinker/fundamental';
import env from '../shared/utils/env';
import {
  ApiBusinessError,
  ApiCancelError,
  ApiNetError,
  UserFriendlyError,
} from '../shared/errors';
import MicroApp from '../micro/MicroApp';
import pkgInfo from '../../package.json';

import models from './models';
import Routes from './Routes';
import history from './history';

const app = createApp({
  history,
  models,
  storeConfig: {
    errorHandler: error => {
      if (
        error instanceof ApiBusinessError ||
        error instanceof ApiNetError ||
        error instanceof ApiCancelError
      ) {
        return;
      }

      // @ts-ignore
      typeof Sentry !== 'undefined' && Sentry.captureException(error);

      if (process.env.NODE_ENV === 'development') {
        console.error(error);
      }

      return new UserFriendlyError('出现了一点小问题~~');
    },
    persist: {
      storageKey: `med-ih-persist-${env.appEnv}`,
      version: pkgInfo.version,
      storage: window.sessionStorage,
    },
  },
});

app.router(({ history }) => {
  return (
    <Router history={history}>
      {/* @ts-ignore */}
      <Routes>
        <MicroApp />
      </Routes>
    </Router>
  );
});

export default app;
